import React, { useEffect, useState } from 'react'
import './Portfolio.css'
import './Common.css'
import portfolioDataTr from '../data/jsons/portfolio.tr.json';
import portfolioDataEn from '../data/jsons/portfolio.en.json';
import ReturnIcon from '../data/icons/Return.svg'

// Slayt eklentisi
import Lightbox from "yet-another-react-lightbox";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";

function Portfolio() {
    const [isEnglish, setIsEnglish] = useState(
        localStorage.getItem('pageLanguage') === 'true'
    );

    useEffect(() => {
        const handleLangChange = () => {
            setIsEnglish(localStorage.getItem('pageLanguage') === 'true');
        };
        window.addEventListener("languageChange", handleLangChange);
        return () => {
            window.removeEventListener("languageChange", handleLangChange);
        };
    }, []);

    const portfolioData = isEnglish ? portfolioDataEn : portfolioDataTr;
    const projects = portfolioData.projects.items;

    const [selectedProject, setSelectedProject] = useState(null);
    const activeProject = projects.find(project => project.id === selectedProject);

    // 2. Lightbox için gerekli state'ler
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    useEffect(() => {
        // Modal veya Lightbox açıkken kaydırmayı engelle
        if (selectedProject || lightboxOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [selectedProject, lightboxOpen]);

    const slides = activeProject?.gallery?.map((img) => ({
        src: require(`../data/${img}`)
    })) || [];

    useEffect(() => {
        if (selectedProject) {
            // Modal açıkken arkadaki sayfanın kaymasını durdur
            document.body.style.overflow = 'hidden';
        } else {
            // Modal kapanınca geri aç
            document.body.style.overflow = 'unset';
        }
    }, [selectedProject]);

    return(
        <div id='Portfolio-Container' className='Containers'>
            <p className='Page-Header'>{portfolioData.header.title}</p>
            <hr className='Header-Line'/>
            
            <p className='Sub-Header'>{portfolioData.projects.header}</p>
            <div id='Portfolios'>
                {projects.map((project) => (
                    <button key={project.id} className='Portfolio-Item' onClick={()=>setSelectedProject(project.id)}>
                        {project.coverPhoto &&
                            <img 
                                src={require(`../data/${project.coverPhoto}`)}
                                alt={project.title} 
                                className='Item-Image'
                            />}
                        <div className='Portfolio-Item-Chips'>
                            {project.tags.map((tag, index) => (
                                <p key={index} className='Portfolio-Item-Chip'>
                                    {tag}
                                </p>
                            ))}
                        </div>
                        <p className='Portfolio-Item-Title'>{project.title}</p>
                        <p className='Portfolio-Item-Date'>{project.date}</p>

                        <p className='Portfolio-Item-Description'>
                            {project.description}
                        </p>
                    </button>
                ))}
            </div>
            {activeProject && (
                <div className='Selected-Project-Background'>
                    <div id='Selected-Project'>
                        <div className='Project-Header'>
                            <p className='Page-Header'>{activeProject.title}</p>
                            <hr className='Header-Line' />
                            <p className='Portfolio-Item-Date'>{activeProject.date}</p>
                            <p className='Portfolio-Item-Description'>{activeProject.description}</p>
                        </div>
                        <div className='Portfolio-Item-Chips'>
                            {activeProject.tags.map((tag, index) => (
                                <p key={index} className='Portfolio-Item-Chip'>{tag}</p>
                            ))}
                        </div>
                        <div className='Resume-Section'>
                            <p className='Resume-Title'>{activeProject.achievements.title}</p>
                            {activeProject.achievements.paragraphs.map((item, index) => (
                                <div className='Items' key={index}>
                                    <div className='Item-Header'>
                                        <p className='Item-Title'>{item.title}</p>
                                    </div>
                                    <p className='Item-Subtitle'>{item.description}</p>
                                </div>
                            ))}
                        </div>
                        {activeProject.deeplink && (
                            <button 
                                className='Id-Contact-Button Download-Button'
                                onClick={() => window.open(activeProject.deeplink.url, '_blank')}
                            >
                                {activeProject.deeplink.title}
                            </button>
                        )}
                        <div className='Resume-Section'>
                            <p className='Resume-Title'>{isEnglish ? ('Example Screenshot Photos:'):('Örnek Ekran Fotoğrafları:')}</p>
                            <div className='Project-Image-Container'>
                                {activeProject.gallery.map((img, index) => (
                                    img && <img 
                                        key={index} 
                                        src={require(`../data/${img}`)} 
                                        className='Project-Image' 
                                        alt={`${activeProject.title} ${index}`}
                                        onClick={() => {
                                            setLightboxIndex(index);
                                            setLightboxOpen(true);
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                        {activeProject.techStack && (
                            <div className='Resume-Section'>
                                <p className='Resume-Title'>{activeProject.techStack.title}</p>
                                {activeProject.techStack.stack.map((stackItem, index) => (
                                    <div className='Items' key={index}>
                                        <div className='Item-Header'>
                                            <p className='Item-Title'>{stackItem.title}</p>
                                        </div>
                                        <p className='Item-Subtitle'>{stackItem.data}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                        <button className='Return-Button' onClick={() => setSelectedProject(null)}>
                            <img className='Return-Icon' src={ReturnIcon} alt="Return" />
                        </button>
                    </div>
                </div>
            )}
            <Lightbox
                open={lightboxOpen}
                close={() => setLightboxOpen(false)}
                slides={slides}
                index={lightboxIndex}
                plugins={[Counter, Zoom]}
                counter={{ 
                    container: { style: { top: "unset", bottom: "20px" } } // Sayacı aşağıya almak istersen
                }}
                zoom={{
                    maxZoomPixelRatio: 3,
                    scrollToZoom: true
                }}
                on={{
                    view: ({ index }) => setLightboxIndex(index), // Slayt değiştikçe index'i güncelle
                }}
            />
        </div>
    );
}

export default Portfolio
